export default "__VITE_ASSET__415b89bd__"